import { BookOpen, ExternalLink } from 'lucide-react'
import Card from '@/components/ui/Card'
import LocalizedLink from '@/components/layout/LocalizedLink'
import { getLocalizedValue } from '@sakeena/shared'
import { useTranslation } from 'react-i18next'

export interface Evidence {
  id: number
  type: 'quran' | 'hadith'
  reference: string
  text: any
  surahId?: number
  ayahNumber?: number
}

interface EvidenceDisplayProps {
  evidences: Evidence[]
}

export default function EvidenceDisplay({ evidences }: EvidenceDisplayProps) {
  const { i18n } = useTranslation()
  const currentLang = i18n.language || 'ar'

  if (evidences.length === 0) {
    return null
  }

  return (
    <Card className="p-6 mt-6 bg-primary-50 border-primary-200">
      <h3 className="text-lg font-bold text-gray-900 mb-4 flex items-center gap-2">
        <BookOpen className="w-5 h-5 text-primary-600" />
        الأدلة الشرعية
      </h3>
      <div className="space-y-4">
        {evidences.map((evidence) => (
          <div key={evidence.id} className="border-r-4 border-primary-500 pr-4">
            <div className="flex items-start justify-between gap-2 mb-2">
              <span className="text-sm font-medium text-primary-700">{evidence.reference}</span>
              {evidence.type === 'quran' && evidence.surahId && (
                <LocalizedLink
                  to={`/quran/${evidence.surahId}`}
                  className="text-xs text-primary-600 hover:text-primary-800 flex items-center gap-1"
                >
                  عرض الآية
                  <ExternalLink className="w-3 h-3" />
                </LocalizedLink>
              )}
            </div>
            <p className="text-gray-900 leading-relaxed" dir="rtl">
              {getLocalizedValue(evidence.text, currentLang)}
            </p>
          </div>
        ))}
      </div>
    </Card>
  )
}
